import React, { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

import Box from '@mui/material/Box';
import { Container, Paper, Grid, Hidden  } from '@mui/material';
import { makeStyles } from '@mui/styles';

import logo from 'assets/logo_horizontal.png';
import Form1 from './Form_1';
import Form4 from './Form_4';
import Form5 from './Form_5';
import Form6 from './Form_6';
import Form8 from './Form_8';
import Success from './success';
import { Typography, colors, Stepper, styles } from '@leapeasy/ui-kit';
import { isCleanEmbedMode } from '../../config/embedMode';
import { fetchTenantAction, setSuccessAction } from '../../redux/actions/shortFormActions';
import { CustomStepperWrapper } from 'components/CustomWrapper';

const useStyles = makeStyles((theme) => ({
  logo: {
    width: 250,
    height: 80,
  },
}));

const steps = [
  {
    label: '1',
    title: 'Personal information',
  },
  {
    label: '2',
    title: 'Lease Detail',
  },
  {
    label: '3',
    title: 'Your Current Address',
  },
  {
    label: '4',
    title: 'Identity Information',
  },
  {
    label: '5',
    title: 'Review',
  },
];

const steps_without_title = [
  {
    label: '1',
    title: '',
  },
  {
    label: '2',
    title: '',
  },
  {
    label: '3',
    title: '',
  },
  {
    label: '4',
    title: '',
  },
  {
    label: '5',
    title: '',
  },
  {
    label: '6',
    title: '',
  },
  {
    label: '7',
    title: '',
  },
];

export default function ClaimForm() {
  const { accountId } = useParams();

  const formData = useSelector((state) => state.shortFormData);

  const [activeStep, setActiveStep] = useState(0);
  const [token, setToken] = useState(null);
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTenantAction(accountId));
  }, []);

  useEffect(() => {
    if (activeStep === 5) return;

    if (formData && formData.data && formData.data.termCheck) {
      dispatch(setSuccessAction('success'));

      setActiveStep(5);
    }
  }, [formData, activeStep]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box
      sx={{
        height: isCleanEmbedMode ? 'auto' : '100%',
        display: 'flex',
        alignItems: isCleanEmbedMode ? 'stretch' : 'flex-start',
        width: isCleanEmbedMode ? '100%' : '1440px',
        maxWidth: isCleanEmbedMode ? '100%' : '90%',
        margin: 'auto',
        px: isCleanEmbedMode ? { xs: 1.5, sm: 2, md: 3 } : 0,
        py: isCleanEmbedMode ? { xs: 1, sm: 2 } : 0,
      }}
    >
      <Grid
        container
        justifyContent={isCleanEmbedMode ? 'center' : 'space-between'}
        alignItems="stretch"
        sx={isCleanEmbedMode ? { width: '100%', maxWidth: '980px', margin: '0 auto' } : { marginTop: 6 }}
      >
        {!isCleanEmbedMode && (
          <Grid
            item
            md={5}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              maxHeight: '80vh',
            }}
          >
            <img src={logo} className={classes.logo} />

            <Box display="flex" flexDirection="column" sx={{ gap: '16px' }}>
              <Typography variant="h2" style={{ color: 'white', fontWeight: '700' }}>
                Welcome to the Secondary <br /> Rent Guaranty Application!
              </Typography>

              <Typography variant="body1" style={{ color: 'white' }}>
                Get access to the apartments you’ve only dreamed of without prepaying rent or making
                your parents co-sign.
              </Typography>
            </Box>
          </Grid>
        )}

        {!isCleanEmbedMode && <Grid item md={0.5} />}

        <Grid item xs={12} md={isCleanEmbedMode ? 12 : 6.5} sx={{ my: isCleanEmbedMode ? 0 : 2 }}>
          <Paper
            sx={{
              borderRadius: '12px',
              padding: 2,
              display: 'flex',
              boxShadow: isCleanEmbedMode ? '0px 8px 24px rgba(16, 24, 40, 0.08)' : undefined,
              width: '100%',
              overflow: 'visible',
            }}
          >
            <Box
              sx={{
                background: colors.purple[100],
                borderRadius: styles.borderRadius.small,
                padding: `${styles.spacing.space12}px ${styles.spacing.space4}px`,
                flexGrow: 0,
                flexShrink: 0,
              }}
            >
              <Stepper
                steps={steps}
                activeStep={activeStep}
                labelAlignment="row"
                stepAlignment="column"
              />
            </Box>


            <Box
              display="flex"
              flexDirection="column"
              padding={{ xs: 0, sm: 4 }}
              gap="20px"
              sx={{ flexGrow: 1 }}
            >
              {formData && formData.data.contact_id && (
                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                  {activeStep === 0 && <Form1 handleNext={handleNext} />}
                  {activeStep === 1 && <Form4 handleNext={handleNext} handleBack={handleBack} />}
                  {activeStep === 2 && <Form5 handleNext={handleNext} handleBack={handleBack} />}
                  {activeStep === 3 && <Form6 handleNext={handleNext} handleBack={handleBack} />}
                  {activeStep === 4 && (
                    <Form8
                      handleNext={handleNext}
                      handleBack={handleBack}
                      handleStep={(value) => setActiveStep(value)}
                    />
                  )}
                  {activeStep === 5 && <Success />}
                </Box>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
